import { render, staticRenderFns } from "./StatisticsMarketingDatabase.vue?vue&type=template&id=c960866e&scoped=true&"
import script from "./StatisticsMarketingDatabase.vue?vue&type=script&lang=js&"
export * from "./StatisticsMarketingDatabase.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsMarketingDatabase.vue?vue&type=style&index=0&id=c960866e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c960866e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAutocomplete,VCard,VCardText,VCardTitle,VCol,VIcon,VProgressLinear,VRow,VSwitch})
